import React from 'react'

function Views({currentView, views}: {currentView: string; views: any}) {
  const activeView = views.find((view: any) => view[0] === currentView)
  return activeView[1]
}

export default Views
